import languageNewVer from "./languageNewVer.json";

export const ko = {
  languageNewVer,
};
export const nameSpace = ["languageNewVer"];
